import { render } from "./EditHoliday.vue?vue&type=template&id=48d79cd0&scoped=true"
import script from "./EditHoliday.vue?vue&type=script&lang=js"
export * from "./EditHoliday.vue?vue&type=script&lang=js"

import "./holiday.scss?vue&type=style&index=0&id=48d79cd0&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d79cd0"]])

export default __exports__